module.exports = __webpack_public_path__ + "media/images/help/flow/eyecatch-bird-9e331f23762e2c30604e0e001d79433d.svg";